import { useEffect, useRef } from "react";
import { get_media_url } from "../../api/utils";

export const FullImageCard = ({ content }) => {
  const imgRef = useRef(null);
  const imgContainerRef = useRef(null);

  useEffect(() => {
    const imgEle = imgRef.current;
    const imgContainerEle = imgContainerRef.current;

    const handleLoaded = () => {
      imgEle.classList.remove("opacity-0");
      imgContainerEle.classList.remove("skeleton");
    };

    if (imgEle && imgContainerRef) {
      if (imgEle.complete) handleLoaded();
      else imgEle.addEventListener("load", handleLoaded);

      return () => {
        imgEle.removeEventListener("load", handleLoaded);
      };
    }
  }, [imgRef, imgContainerRef]);

  return (
    <div
      ref={imgContainerRef}
      className="w-full h-full text-center text-lg font-semibold cursor-pointer bg-[#2C2D36] skeleton"
    >
      <img
        ref={imgRef}
        className="w-full h-full object-cover opacity-0 transition-opacity duration-300"
        alt="postimage"
        src={get_media_url(content.foreground_image)}
      />
    </div>
  );
};
